import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { insertIf } from '@backmarket/utils/collection/insertIf'

import { GIFT_CARDS } from './routes.constants'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const { features } = useMarketplace()
  const isGiftCardsEnabled =
    experiments['experiment.giftCards'] === 'withGiftCards' &&
    features.giftCards.enabled

  return [
    ...(insertIf(isGiftCardsEnabled, [
      {
        path: 'gift-cards',
        name: GIFT_CARDS.INDEX,
        component: () => import('./pages/GiftCards/GiftCards.vue'),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
        },
      },
    ]) as RouteRecordRaw[]),
  ]
}
